<vue-page-header
        [pageTitle]="'menu.Affiliates' | translate | async">
</vue-page-header>
<vue-server-messages [messages]="messages"></vue-server-messages>
<vue-panel id="SiteAffiliateManagement">
  <vue-search
          i18nBundle="PortalBase"
          [label]="'label.SearchAffiliates' | translate | async"
          [(genericSearchField)]="searchText"
          (basicSearchButtonClicked)="searchSites()">
  </vue-search>
  <div class="table-bar">
    <div class="table-container">
      <table class="table table-edit">
        <thead>
        <tr>
          <th>
            <vue-sort fieldName="siteID"
                      [sortField]="sortField"
                      (sortChange)="sortChange($event)">
              {{ 'label.SiteID' | translate | async }}
            </vue-sort>
          </th>
          <th>
            <vue-sort fieldName="name"
                      [sortField]="sortField"
                      (sortChange)="sortChange($event)">
              {{ 'label.SiteName' | translate | async }}
            </vue-sort>
          </th>
          <th>
            <vue-sort fieldName="city"
                      [sortField]="sortField"
                      (sortChange)="sortChange($event)">
              {{ 'label.AffiliateCity' | translate | async }}
            </vue-sort>
          </th>
          <th>
            <vue-sort fieldName="state"
                      [sortField]="sortField"
                      (sortChange)="sortChange($event)">
              {{ 'label.AffiliateState' | translate | async }}
            </vue-sort>
          </th>
          <th>
            <vue-sort fieldName="country"
                      [sortField]="sortField"
                      (sortChange)="sortChange($event)">
              {{ 'label.AffiliateCountry' | translate | async }}
            </vue-sort>
          </th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let affiliate of currentPageAffiliates">
          <td [attr.aria-label]= "'label.SiteID' | translate | async">
            {{ affiliate.siteId }}
          </td>
          <td [attr.aria-label] = "'label.SiteName' | translate | async">
            {{ affiliate.name }}
            <span *ngIf="affiliate.siteId.toString() === realmDetail.siteID">({{ 'label.LocalSite' | translate | async }})</span>
          </td>
          <td [attr.aria-label] = "'label.AffiliateCity' | translate | async">
            {{ affiliate.city }}
          </td>
          <td [attr.aria-label] = "'label.AffiliateState' | translate | async">
            {{ affiliate.state }}
          </td>
          <td [attr.aria-label] = "'label.AffiliateCountry' | translate | async">
            {{ affiliate.country }}
          </td>
          <td>
            <button id="action1Btn{{ affiliate.siteId }}"
                    class="btn btn-default btn-xs action-btn"
                    type="submit"
                    (click)="onSwitchAffiliate(affiliate)">
              {{ 'button.Manage' | translate | async }}
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="text-center" *ngIf="totalRows === 0 || (currentPageAffiliates && currentPageAffiliates.length === 0)">
        <br><br>
        {{ 'label.NoAffiliates' | translate | async }}
        <br><br>
      </div>
    </div>
  </div>
  <div class="table-bottom-bar table-options" *ngIf="currentPageAffiliates && currentPageAffiliates.length !== 0">
    <div class="table-options">
      <vue-page-rows i18nBundle="PortalBase"
                     [pageNumber]="pageNumber"
                     [pageRows]="pageRows"
                     [pageSize]="pageSize"
                     [totalRows]="totalRows"
                     [dropup]="true"
                     (changePageClicked)="pageSizeChange($event)">
      </vue-page-rows>
    </div>
    <div class="table-pagination">
      <vue-pagination boundaryLinks="true"
                      maxSize="5"
                      rotate="false"
                      directionLinks="true"
                      [pageNumber]="pageNumber"
                      [pageSize]="pageSize"
                      [totalRows]="totalRows"
                      (pageChange)="pageNumberChange($event)">
      </vue-pagination>
    </div>
  </div>
</vue-panel>


